<template>
<!--<v-responsive class="overflow-y-auto" :max-height="$store.state.maxHeight">-->
<div id="about">
    <section id="hero">
      <v-row no-gutters>
          <v-img :min-height="'calc(100vh - ' + $vuetify.application.top + 'px)'" src="/static/img/about2.png" style="height:80vh;">
           <v-theme-provider>
            <v-container fill-height>
              <v-row align="center" class="white--text mx-auto" justify="center">
                <!-- <v-col class="white--text text-center" cols="12" tag="h1">
                  <span :class="[$vuetify.breakpoint.smAndDown ? 'display-1' : 'display-2']" class="font-weight-light">
                    Welcome To
                  </span>
                  <span :class="[$vuetify.breakpoint.smAndDown ? 'display-3': 'display-4']" class="font-weight-black">
                    <br>ETOAK
                  </span>
                </v-col> -->
                <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#features')">
                  <v-icon>mdi-chevron-double-down</v-icon>
                </v-btn>
              </v-row>
            </v-container>
          </v-theme-provider>
        </v-img>
      </v-row>
    </section>

    <!-- <section id="about-me">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">关于易途</h2>

        <v-responsive class="mx-auto mb-8" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-responsive class="mx-auto title font-weight-light mb-8" max-width="720">
          山东易途信息科技有限公司坐落于山东省济南市趵突泉北路6号蓝石商务中心4层。是一家集教育培训、技术咨询、软件开发、软件外包、人才外包、企业服务于一体的高新技术公司，于2008年8月由广州入驻山东济南。易途科技技术人才实力雄厚,人才培养紧跟市场的需求，凭借强大的技术实力和多年积累的软件外包经验，为国内众多互联网和实体行业的知名公司提供了软件相关服务。
        </v-responsive>

        <v-avatar class="elevation-12 mb-12" size="128">
          <v-img src="/static/img/etoak.png"></v-img>
        </v-avatar>

        <div></div>

        <v-btn color="grey" href="http://www.etoak.com" outlined large>
          <span class="grey--text text--lighten-1 font-weight-bold">
            走进易途
          </span>
        </v-btn>
      </v-container>

      <div class="py-12"></div>
    </section> -->

    <section id="features" class="lighten-3">
      <div class="py-12"></div>

      <v-container class="text-center">
        <h2 class="display-2 font-weight-bold mb-3">公司介绍</h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>
          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col v-for="({ icon, title, text }, i) in features" :key="i" cols="12" md="4">
            <v-card class="py-12 px-4" color="lighten-5" flat>
              <v-theme-provider>
                <div>
                  <v-avatar color="primary" size="88">
                    <v-icon large v-text="icon"></v-icon>
                  </v-avatar>
                </div>
              </v-theme-provider>

              <v-card-title class="justify-center font-weight-black text-uppercase" v-text="title"></v-card-title>

              <v-card-text class="subtitle-1" v-text="text" style="text-align: left;">
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>


      </v-container>

      <v-row align="center" class="white--text mx-auto" justify="center">
        <v-btn class="align-self-end" fab outlined @click="$vuetify.goTo('#stats')">
          <v-icon>mdi-chevron-double-down</v-icon>
        </v-btn>
      </v-row>
      <div class="py-12"></div>

    </section>


    <section id="stats">
      <!-- src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80" -->
      <v-parallax :height="$vuetify.breakpoint.smAndDown ? 700 : 500" src="https://images.unsplash.com/photo-1510915228340-29c85a43dcfe?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1950&q=80">
        <v-container fill-height>
          <v-row class="mx-auto">
            <v-col v-for="[value, title] of stats" :key="title" cols="12" md="3">
              <div class="text-center">
                <div class="display-3 font-weight-black mb-4" v-text="value"></div>

                <div class="title font-weight-regular text-uppercase" v-text="title"></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-parallax>
    </section>

    <section id="blog">
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">微信公众号</h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-row>
          <v-col v-for="({ src, text, title, href }, i) in articles" :key="i" cols="12" md="4">
            <v-img :src="src" class="mb-4" height="275" max-width="100%"></v-img>

            <h3 class="font-weight-black mb-4 text-uppercase" v-text="title"></h3>

            <div class="title font-weight-light mb-5" v-text="text"></div>

            <v-btn class="ml-n4 font-weight-black" text :href="href" target="_blank">
              Continue Reading
            </v-btn>
          </v-col>
        </v-row>
      </v-container>

      <div class="py-12"></div>
    </section>

    <!-- <v-sheet id="contact" color="#333333" tag="section" tile>
      <div class="py-12"></div>

      <v-container>
        <h2 class="display-2 font-weight-bold mb-3 text-uppercase text-center">联系我们</h2>

        <v-responsive class="mx-auto mb-12" width="56">
          <v-divider class="mb-1"></v-divider>

          <v-divider></v-divider>
        </v-responsive>

        <v-theme-provider>
          <v-row>
            <v-col cols="12">
              <v-text-field flat label="Name*" solo></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field flat label="Email*" solo></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-text-field flat label="Subject*" solo></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-textarea flat label="Message*" solo></v-textarea>
            </v-col>

            <v-col class="mx-auto" cols="auto">
              <v-btn color="green" x-large>
                Submit
              </v-btn>
            </v-col>
          </v-row>
        </v-theme-provider>
      </v-container>

      <div class="py-12"></div>
    </v-sheet> -->
</div>
<!--</v-responsive>-->
</template>
<script>
  export default {
    name: 'account-head',
    data() {
      return {
        articles: [{
            src: '/static/img/keyboard.jpg',
            title: '疫情丨易情',
            text: '无穷的远方，无数的人数，都和我有关',
            href: 'https://mp.weixin.qq.com/s/w8pHehJtgY0aQDQv6-dikg'
          },
          {
            src: '/static/img/401.jpg',
            title: '那些杀不死你的 终将会让你更强大',
            text: '你是已经安稳沉睡 还是依然在野蛮生长？',
            href: 'https://mp.weixin.qq.com/s/G2upCL5x-k-_iopYtFc3jA'
          },
          {
            src: '/static/img/dabai.jpg',
            title: '那些在蓝石大厦晚出晚归的“嫐”',
            text: '这期的主人公是总部的辅导员老师们 你们辛苦了！',
            href: 'https://mp.weixin.qq.com/s/vGL5dqRNRhXwlPFbMm0YxQ'
          },
        ],
        features: [{
            icon: 'mdi-book-open-page-variant',
            title: '教培',
            text: '教学是件趣事，把知识盘活是个技术活，12年从业经验的易途对此很有信心：业内上流执教讲师，项目一线返聘随班助教，单从硬件上已是顶级。从软件层面来说：受益于几百人团队的外包研发团队，前沿技术始终同我们如影随形，并将之同部到课堂之上供同学们尽欢。师当如此，夫复何求？',
          },
          {
            icon: 'mdi-contacts-outline',
            title: '外包',
            text: '让每位学员学有所成是易途的本份，让每位易途人都成有所劳是易途的基操，让每位易途人都劳值所获是易途的天职。外包的成立打破了行业多年的潜规：透明合同、透明薪资让每一位易家人都知道TA的身价几何，让每秒的耕耘都有着可期的收获。引领行业优化，尊重每一位程序员工程师，路漫漫，易前行。',
          },
          {
            icon: 'mdi-bug-check',
            title: '研发',
            text: '研发是一个严谨的词汇：研究是一种态度，厚积薄发是一种表现。八十一，欲取经，易途研发部成立。历年积淀下振臂一呼而应者云集。万物互联的时代里我们是新世界的先行者与缔造者。优化资源、简化繁琐、美化生活、催化变革。易途轻且优的Coder们正在各乘风浪，Debug the world.',
          },
        ],
        stats: [
          ['10年', '培训经验丰富'],
          ['8k', '培训过的人数'],
          ['12000', '平均月薪'],
          ['120+', '外包服务城市']
        ]
      }
    },
    mounted(){

    },
  }
</script>



// WEBPACK FOOTER //
// src/page/about/index.vue